import { DateTime } from 'luxon';
import { FC, memo, useState } from 'react';
import { LiaClipboardListSolid } from 'react-icons/lia';
import { toast } from 'react-toastify';
import { formatISODate } from '../../../pages/AppPages/pqfl/visits/components/table';

import { PQFLVisitCardContainer } from './styles';
import { IPQFLVisitCard } from './types';

const PQFLVisitCard: FC<IPQFLVisitCard> = memo(
  ({ visit, onVisualize, onPrint }) => {
    const [isPrinting, setIsPrinting] = useState(false);

    const handlePrint = async () => {
      if (isPrinting) return;
      setIsPrinting(true);

      try {
        await onPrint(visit);
      } catch (error) {
        toast.error('Erro ao imprimir');
      } finally {
        setIsPrinting(false);
      }
    };

    const handleVisualize = () => {
      onVisualize(visit);
    };

    return (
      <PQFLVisitCardContainer>
        <div className="card-title">
          <LiaClipboardListSolid />
          <h1>Visita #{visit.id}</h1>
        </div>

        <div className="visit-item-row">
          <div className="item-row-medium-with-border">
            <span>
              <strong>Propriedade:</strong> {visit.propriedade.nome_propriedade}
            </span>
          </div>
          <div className="item-row-medium">
            <span>
              <strong>Produtor:</strong> {visit.propriedade.nome_produtor}
            </span>
          </div>
        </div>

        <div className="visit-item-row">
          <div className="item-row-medium-with-border">
            <span>
              <strong>Responsável:</strong> {visit.funcionario.nome}
            </span>
          </div>
          <div className="item-row-medium">
            <span>
              <strong>Status:</strong> {visit.status}
            </span>
          </div>
        </div>

        <div className="visit-item-row">
          <div className="item-row-medium-with-border">
            <span>
              <strong>Início:</strong> {formatISODate(visit.data_inicio)}
            </span>
          </div>
          <div className="item-row-medium">
            <span>
              <strong>Fim:</strong> {formatISODate(visit.data_final)}
            </span>
          </div>
        </div>

        {visit.recomendacao_tecnica && (
          <div className="visit-item-row">
            <div className="item-row">
              <span>
                <strong>Recomendação:</strong> {visit.recomendacao_tecnica}
              </span>
            </div>
          </div>
        )}

        <footer className="card-footer">
          <button className="visualize" onClick={handleVisualize}>
            Visualizar
          </button>
          <button className="print" onClick={handlePrint} disabled={isPrinting}>
            {isPrinting ? 'Imprimindo...' : 'Imprimir'}
          </button>
        </footer>
      </PQFLVisitCardContainer>
    );
  },
);

PQFLVisitCard.displayName = 'PQFLVisitCard';

export { PQFLVisitCard };
